import { render, staticRenderFns } from "./ExhibitionBanner.vue?vue&type=template&id=6d3010d2&scoped=true"
var script = {}
import style0 from "./ExhibitionBanner.vue?vue&type=style&index=0&id=6d3010d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3010d2",
  null
  
)

export default component.exports